import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function ProfileLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'account-menu-profile-link'}
            title={intl.formatMessage({id: 'accountMenu.link.profile.title'})}
            to={Routes.ACCOUNT_PROFILE}
        >
            <span>
                <FormattedMessage id={'accountMenu.link.profile.text'} />
            </span>
        </NavLink>
    );
}
